import { render, staticRenderFns } from "./MigracaoDados.vue?vue&type=template&id=b133e81a&"
import script from "./MigracaoDados.vue?vue&type=script&lang=js&"
export * from "./MigracaoDados.vue?vue&type=script&lang=js&"
import style0 from "./MigracaoDados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports